<div class="hold-transition sidebar-mini layout-navbar-fixed layout-footer-fixed">
    <div class="wrapper">
        <app-header></app-header>
        <app-sidebar [page]="'finance-pl'" [subPage]="activeSection.slug"></app-sidebar>

        <div class="content-wrapper">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-7">
                            <h1 class="m-0">{{ activeSection.title }}</h1>
                            <p class="mb-0">{{ activeSection.summary }}</p>
                        </div>
                        <div class="col-sm-5">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a [routerLink]="['/']">Home</a></li>
                                <li class="breadcrumb-item active">{{ activeSection.title }}</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section class="content">
                <div class="container-fluid">
                    <app-module-menu [module]="'finance'" [activeSlug]="activeSection.slug"></app-module-menu>
                    <ng-container *ngIf="activeSection.slug === 'pl-statement'">
                        <div class="finance-restricted" *ngIf="!canViewPl">
                            <i class="fas fa-lock"></i>
                            <h3>Access Restricted</h3>
                            <p>The P&amp;L statement is only visible to the CFO, COO, and CEO.</p>
                        </div>

                        <div class="card" *ngIf="canViewPl">
                            <div class="card-header">
                                <h3 class="card-title">P&amp;L Statement</h3>
                            </div>
                            <div class="card-body">
                                <form [formGroup]="periodForm" (ngSubmit)="refreshPl()" class="form-row">
                                    <div class="form-group col-md-3">
                                        <label>Period</label>
                                        <select class="form-control" formControlName="period">
                                            <option value="monthly">Monthly</option>
                                            <option value="quarterly">Quarterly</option>
                                            <option value="annual">Annual</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label>Date</label>
                                        <input type="date" class="form-control" formControlName="date">
                                    </div>
                                    <div class="form-group col-md-2 d-flex align-items-end">
                                        <button class="btn btn-primary btn-block" type="submit">Apply</button>
                                    </div>
                                </form>
                                <div class="row" *ngIf="pl">
                                    <div class="col-md-4"><div class="small-box bg-success"><div class="inner"><h3>{{ pl.income | number:'1.2-2' }}</h3><p>Income</p></div></div></div>
                                    <div class="col-md-4"><div class="small-box bg-danger"><div class="inner"><h3>{{ pl.expense | number:'1.2-2' }}</h3><p>Expense</p></div></div></div>
                                    <div class="col-md-4"><div class="small-box bg-info"><div class="inner"><h3>{{ pl.net | number:'1.2-2' }}</h3><p>Net</p></div></div></div>
                                </div>
                                <div class="finance-chart" *ngIf="pl?.trend?.length">
                                    <div class="finance-chart-row" *ngFor="let row of pl.trend">
                                        <span>{{ row.label }}</span>
                                        <div class="finance-bar-track"><div class="finance-bar income" [style.width]="barWidth(row.income)"></div></div>
                                        <div class="finance-bar-track"><div class="finance-bar expense" [style.width]="barWidth(row.expense)"></div></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="activeSection.slug === 'manual-expense-input'">
                        <div class="card">
                            <div class="card-header"><h3 class="card-title">Manual Expense Input</h3></div>
                            <div class="card-body">
                                <form [formGroup]="expenseForm" (ngSubmit)="submitExpense()" class="form-row">
                                    <div class="form-group col-md-3"><label>Category</label><input class="form-control" formControlName="category"></div>
                                    <div class="form-group col-md-2"><label>Amount</label><input type="number" class="form-control" formControlName="amount"></div>
                                    <div class="form-group col-md-2"><label>Date</label><input type="date" class="form-control" formControlName="expenseDate"></div>
                                    <div class="form-group col-md-3"><label>Receipt</label><input type="file" class="form-control" accept=".pdf,image/*" (change)="receiptSelected($event)"></div>
                                    <div class="form-group col-md-2 d-flex align-items-end"><button class="btn btn-primary btn-block" type="submit">Submit</button></div>
                                    <div class="form-group col-md-12"><label>Description</label><textarea class="form-control" rows="3" formControlName="description"></textarea></div>
                                </form>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover">
                                    <thead><tr><th>Date</th><th>Category</th><th>Description</th><th>Amount</th><th>Status</th><th>Receipt</th></tr></thead>
                                    <tbody><tr *ngFor="let row of expenses"><td>{{ row.expenseDate }}</td><td>{{ row.category }}</td><td>{{ row.description }}</td><td>{{ row.amount | number:'1.2-2' }}</td><td><span class="badge badge-warning">{{ row.status }}</span></td><td>{{ row.receiptPath ? 'Uploaded' : '-' }}</td></tr></tbody>
                                </table>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="activeSection.slug === 'trade-income-recognition'">
                        <div class="card">
                            <div class="card-header"><h3 class="card-title">Trade Income Recording</h3></div>
                            <div class="card-body">
                                <form [formGroup]="incomeForm" (ngSubmit)="recognizeIncome()" class="form-row">
                                    <div class="form-group col-md-4"><label>Trade</label><select class="form-control" formControlName="tradeRef"><option value="">Select trade</option><option *ngFor="let trade of trades" [value]="trade.ref">{{ tradeLabel(trade) }}</option></select></div>
                                    <div class="form-group col-md-2"><label>Amount</label><input type="number" class="form-control" formControlName="amount"></div>
                                    <div class="form-group col-md-2"><label>Date</label><input type="date" class="form-control" formControlName="incomeDate"></div>
                                    <div class="form-group col-md-2"><label>Category</label><input class="form-control" formControlName="category"></div>
                                    <div class="form-group col-md-2 d-flex align-items-end"><button class="btn btn-primary btn-block" type="submit">Recognize</button></div>
                                    <div class="form-group col-md-12"><label>Notes</label><textarea class="form-control" rows="2" formControlName="notes"></textarea></div>
                                </form>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover">
                                    <thead><tr><th>Date</th><th>Trade</th><th>Category</th><th>Amount</th><th>Notes</th><th>Status</th></tr></thead>
                                    <tbody><tr *ngFor="let row of incomes"><td>{{ row.incomeDate }}</td><td>{{ row.tradeRef || '-' }}</td><td>{{ row.category }}</td><td>{{ row.amount | number:'1.2-2' }}</td><td>{{ row.notes }}</td><td><span class="badge badge-success">{{ row.status }}</span></td></tr></tbody>
                                </table>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="activeSection.slug === 'income-expense-exports'">
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title">Income and Expense Exports</h3>
                                <div class="card-tools"><button class="btn btn-sm btn-success" (click)="exportFinanceData(exportForm.value.format)"><i class="fas fa-download"></i> Download</button></div>
                            </div>
                            <div class="card-body">
                                <form [formGroup]="exportForm" class="form-row">
                                    <div class="form-group col-md-3"><label>From</label><input type="date" class="form-control" formControlName="dateFrom"></div>
                                    <div class="form-group col-md-3"><label>To</label><input type="date" class="form-control" formControlName="dateTo"></div>
                                    <div class="form-group col-md-3"><label>Category</label><select class="form-control" formControlName="category"><option value="">All</option><option *ngFor="let category of categories" [value]="category">{{ category }}</option></select></div>
                                    <div class="form-group col-md-3"><label>Format</label><select class="form-control" formControlName="format"><option>Excel</option><option>PDF</option></select></div>
                                </form>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover">
                                    <thead><tr><th>Type</th><th>Date</th><th>Category</th><th>Amount</th><th>Description/Notes</th></tr></thead>
                                    <tbody>
                                        <tr *ngFor="let row of filteredIncomes()"><td>Income</td><td>{{ row.incomeDate }}</td><td>{{ row.category }}</td><td>{{ row.amount | number:'1.2-2' }}</td><td>{{ row.notes }}</td></tr>
                                        <tr *ngFor="let row of filteredExpenses()"><td>Expense</td><td>{{ row.expenseDate }}</td><td>{{ row.category }}</td><td>{{ row.amount | number:'1.2-2' }}</td><td>{{ row.description }}</td></tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </section>
        </div>

        <app-footer></app-footer>
    </div>
</div>
